module.exports = __webpack_public_path__ + "static/media/ic_bluemedia.855a51cb.svg";